import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import "./BackToTop.css";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation(); // detects route change

  const toggleVisibility = () => {
    setVisible(window.pageYOffset > 200);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Auto scroll to top on route change / navigation
  useEffect(() => {
    scrollToTop();
  }, [location.pathname]); 

  return (
    <div
      className={`backTop-container ${visible ? "backTop-show" : ""}`}
      onClick={scrollToTop}
    >
      <FaArrowUp className="backTop-icon" />
    </div>
  );
};

export default BackToTop;
